import { render, staticRenderFns } from "./campaign-subject-section.vue?vue&type=template&id=f91a42a4"
import script from "./campaign-subject-section.vue?vue&type=script&lang=js"
export * from "./campaign-subject-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports